import React from 'react';
import { useDispatch } from 'react-redux';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';
import PropTypes from 'prop-types';

import { track } from 'components/Services/Analytics/AnalyticsService';

const PayoutsButton = ({ appPathName, appName }) => {
  const dispatch = useDispatch();
  const handleTellMeMore = () => {
    dispatch(
      track('Click', {
        button_name: 'tell me more',
        app_name: appPathName,
        pathname: `/pro/apps/details/${appPathName}`,
      })
    );

    Intercom('showNewMessage', `Can you tell me more about ${appName}?`);
  };
  return (
    <>
      <Button variant="contained" color="primary" href="/pro/my_money" style={{ marginRight: '16px' }}>
        View payouts info
      </Button>
      <Button variant="outlined" color="primary" onClick={handleTellMeMore}>
        Tell Me More
      </Button>
    </>
  );
};

PayoutsButton.propTypes = {
  appPathName: PropTypes.string.isRequired,
  appName: PropTypes.string.isRequired,
};

export default PayoutsButton;
